import React from "react";
import Header from "./Header";
import Actions from "./Actions";
import EmptyState from "./EmptyState";
import Selections from "./Selections";
import Summary from "./Summary";
import { useBetSlip } from "../providers/BetSlipProvider";
import BetBuilder from "./BetBuilder";

export const BetSlip: React.FC = () => {
  const { betSlipState } = useBetSlip();

  return (
    <div className="bg-betslip-bg text-body-text">
      {/* Header - Mode Selection */}
      {(betSlipState.selections.length > 0 ||
        betSlipState.betBuilderState.bets.length > 0) && (
        <div className="">
          <Header />
        </div>
      )}

      {/* Actions - Accept Changes, Remove All */}
      <div className="px-4 border-t border-b border-solid border-betslip-border">
        <Actions />
      </div>

      {/* Content */}
      <div>
        {betSlipState.selections.length === 0 &&
          betSlipState.betBuilderState.bets.length === 0 && <EmptyState />}
        <Selections />
        <BetBuilder />
        {(betSlipState.selections.length > 0 ||
          betSlipState.betBuilderState.bets.length > 0) && <Summary />}
      </div>
    </div>
  );
};

export default BetSlip;
